// react
import styled from 'styled-components';

// radix
import * as ToggleGroup from '@radix-ui/react-toggle-group';

// components
import { Icon, Icons } from '@/components/atoms/Icon';
import { BaseField, FieldProps } from '@/components/atoms/BaseField/BaseField';

export const ToggleSelect = ({
  id,
  label,
  description,
  tooltip,
  value,
  onChange,
  options,
  placeholder = '',
  ariaLabel,
  isDisabled = false,
  isRequired = false,
  isHideTitle = false,
  defaultValue = '',
  ...props
}: ToggleSelectProps) => {
  return (
    <BaseField
      id={id}
      label={label}
      description={description}
      tooltip={tooltip}
      isRequired={isRequired}
      isHideTitle={isHideTitle}
    >
      <StyledToggleButtonGroup
        type='single'
        value={value}
        defaultValue={defaultValue || options[0].value}
        onValueChange={onChange}
      >
        {options?.map((option: Option) => (
          <StyledToggleButton key={option.value} value={option.value}>
            {option.icon && (
              <IconWrapper>
                <Icon fontSize={16} type={'fal'} icon={option.icon as Icons} />
              </IconWrapper>
            )}
            {option.label}
          </StyledToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </BaseField>
  );
};

const StyledToggleButtonGroup = styled(ToggleGroup.Root)`
  display: flex;
  flex-direction: row;
  border: 1px solid ${(props) => props.theme.color.neutral[50]};
  border-radius: 4px;
  overflow: hidden;
`;

const StyledToggleButton = styled(ToggleGroup.Item)`
  padding: ${(props) => props.theme.spacing[8]};
  flex-grow: 1;
  user-select: none;
  cursor: pointer;
  border: none;
  color: black;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &[data-state='on'] {
    background-color: ${(props) => props.theme.color.neutral[30]};
  }

  &:focus {
    outline: none;
    background-color: ${(props) => props.theme.color.neutral[30]};
  }
  background: ${(props) => props.theme.color.neutral[10]};
`;

const IconWrapper = styled.div`
  all: unset;
  display: flex;
  padding-right: ${(props) => props.theme.spacing[8]};
`;

interface Option {
  label: string;
  value: string;
  icon?: string;
}

export interface ToggleSelectProps extends FieldProps<string> {
  id?: string;
  options: Option[];
  defaultValue?: string;
}

ToggleSelect.displayName = 'ToggleSelect';

export default ToggleSelect;
